import '@aon/aon-tws-common-ui/build/lib/assets/fonts/fonts.css';
import '@aon/aon-tws-common-ui/build/lib/assets/icons/tws-icons.css';
// These css are required to stay above the other imports or they override some of the styled-components
import 'bootstrap-css-only/css/bootstrap.min.css';
import 'core-js/stable';
import '@aon/mdbreact/dist/css/mdb.css';
import 'regenerator-runtime/runtime';
import './assets/css/site.css';
/* eslint-disable react/no-children-prop */
import { SecurityRouter } from '@aon/aon-tws-auth-common-web';
import { AppDynamics, createPendo, IWindow } from '@aon/aon-tws-common-ui/build/lib/utils';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { User } from 'oidc-client';
import { connect, Provider } from 'react-redux';
import { Route, Router } from 'react-router-dom';
import { ConnectedRouter } from 'react-router-redux';
import { AnyAction } from 'redux';
import { getStore, history } from './appStore';
import Constants, { getStringFromConfig } from './constants';
import { HubConnectionName } from './models/HubConnectionName';
import registerServiceWorker from './registerServiceWorker';
import { Routes } from './routes';
import { IApplicationState } from './store';
import { ActionCreators as NotificationStore } from './store/NotificationStore';
import userManager from './userManager';
import { startAppListening } from './appStore';

require('react-hot-loader/patch');

// Pendo Analytics
if ((window as unknown as IWindow).pendo == null && Constants.PENDO_APP_KEY !== 'ERROR!ERROR!') createPendo(Constants.PENDO_APP_KEY);
startAppListening({
	predicate: (action, _) => action.type == 'redux-oidc/USER_FOUND',
	effect: (action, _) => {
		const pendo = (window as unknown as IWindow).pendo;
		const user = action.payload?.profile;
		if (pendo && user) {
			pendo.initialize({
				visitor: {
					id: user.sid,
					environment: getStringFromConfig('REACT_APP_APPENVIRONMENT'),
					email: user.email,
					name: user.name,
					roles: user.userType,
					auth_identifier: 'SurveyBuilder',
				},
				account: {
					id: user.external_clientid,
				},
			});
		}
	},
});

// AppDynamics
AppDynamics.initialize(Constants.APPDYNAMICS_APP_KEY);

const ConnectedSecurityRouter: any = connect((state: IApplicationState) => ({
	user: state.oidc.user,
	isLoadingUser: state.oidc.isLoadingUser,
	userManager,
}))(SecurityRouter);

const routes = (
	<Router history={history}>
		<Route
			path='*'
			render={(props) => (
				<ConnectedSecurityRouter {...props}>
					<Routes />
				</ConnectedSecurityRouter>
			)}
		/>
	</Router>
);

class SignalRConnecter extends React.PureComponent<{
	ConnectToSignalR: (user: User, hubConnectionName: HubConnectionName, dispatchType: AnyAction) => void;
	DisconnectSignalR: (hubConnectionName: HubConnectionName) => void;
	user?: User;
}> {
	public componentDidUpdate(oldProps: any) {
		// Uncomment to call ConnectToSignalR here when we need a centralized hubConnection.
		// if (this.props.user && !oldProps.user) {
		// this.props.ConnectToSignalR(this.props.user!, ...);
		// }
	}

	// Uncomment to call ConnectToSignalR here when we need a centralized hubConnection.
	// public componentWillUnmount() {
	// 	this.props.DisconnectSignalR(hubConnectionName);
	// }

	public render() {
		return <> </>;
	}
}

const ConnectedSignalRConnecter = connect((state: IApplicationState) => ({ user: state.oidc.user }), NotificationStore)(SignalRConnecter);

// This is a workaround for IE 11 local storage synchronization issue
// https://stackoverflow.com/questions/22518785/html5-local-storage-data-not-reflected-across-active-tabs-windows-in-ie-11
// eslint-disable-next-line @typescript-eslint/no-empty-function
window.onstorage = () => {};

const store = getStore();

function renderApp() {
	// This code starts up the React app when it runs in a browser. It sets up the routing configuration
	// and injects the app into a DOM element.
	ReactDOM.render(
		<Provider store={store}>
			<div>
				<ConnectedSignalRConnecter />
				<ConnectedRouter history={history} children={routes} store={store} />
			</div>
		</Provider>,
		document.getElementById('root'),
	);
}

renderApp();
registerServiceWorker();
